import { useTranslation } from '../../hook/useTranslation';

interface IntelligenceExistYNProps {
  rank: number; // 1: 관찰, 2: 관찰불가
}

export default function IntelligenceExistYN({ rank }: IntelligenceExistYNProps) {
  const { t } = useTranslation();
  let label = t('report.observation.observed');
  let style: React.CSSProperties = { backgroundColor: '#F0FCFC', color: '#5EBEBB' };

  if (rank === 1) {
    label = t('report.observation.observed');
    style = { backgroundColor: '#F0FCFC', color: '#5EBEBB' };
  } else if (rank === 2) {
    label = t('report.observation.not_observed');
    style = { backgroundColor: '#F8F8F8', color: '#969696' };
  } else {
    return null;
  }

  return (
    <div
      className="h-[25px] w-auto text-[#5EBEBB] rounded-xl text-[12px] font-[600] px-3 py-[2px] flex items-center justify-center whitespace-nowrap"
      style={style}
    >
      {label}
    </div>
  );
}
